import { render, staticRenderFns } from "./gj-import-alert.vue?vue&type=template&id=34209046&scoped=true&"
import script from "./gj-import-alert.vue?vue&type=script&lang=js&"
export * from "./gj-import-alert.vue?vue&type=script&lang=js&"
import style0 from "./gj-import-alert.vue?vue&type=style&index=0&id=34209046&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34209046",
  null
  
)

export default component.exports